import { createUseRecipeHook, RecipeVariants } from '@theme';
import * as style from './Container.css';

export const useContainerStyle = createUseRecipeHook(style.root);
export type ContainerStyleProps = RecipeVariants<typeof style.root>;
